import { render } from "./privacyPage.vue?vue&type=template&id=71c62a36&scoped=true&ts=true"
import script from "./privacyPage.vue?vue&type=script&lang=ts"
export * from "./privacyPage.vue?vue&type=script&lang=ts"

import "./privacyPage.vue?vue&type=style&index=0&id=71c62a36&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-71c62a36"]])

export default __exports__